import { useState } from "react";
import axios from "axios";
import { Button } from "@mui/material";
import { toast } from "react-hot-toast";

interface QueryResponseFormProps {
  queryId: string;
  questionNumber: string;
  onSuccess?: () => void;
}

export default function QueryResponseForm({
  queryId,
  questionNumber,
  onSuccess,
}: QueryResponseFormProps) {
  const [answer, setAnswer] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const accessToken = user?.accessToken;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!answer.trim()) {
      toast.error("Please enter an answer");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/query/respond/${queryId}`,
        {
          answer: answer,
          questionNumber: questionNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Response submitted successfully");
        setAnswer("");
        onSuccess?.();
      }
    } catch (error) {
      console.error("Error submitting response:", error);
      toast.error("Failed to submit response");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <textarea
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          placeholder="Enter your answer..."
          className="w-full min-h-[100px] p-3 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white text-black"
          disabled={isSubmitting}
        />
      </div>
      <Button
        type="submit"
        disabled={isSubmitting}
        sx={{
          backgroundColor: "#1E3359",
          color: "white",
          "&:hover": {
            backgroundColor: "#16304f",
          },
          "&:disabled": {
            backgroundColor: "#1E3359",
            opacity: 0.7,
          },
        }}
      >
        {isSubmitting ? "Submitting..." : "Submit Response"}
      </Button>
    </form>
  );
}
